import React from 'react';
import { ArrowRight } from 'lucide-react';
interface MysticalButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  children: React.ReactNode;
  icon?: boolean;
}
export function MysticalButton({
  variant = 'primary',
  children,
  className = '',
  icon = true,
  ...props
}: MysticalButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-sm font-bold tracking-widest uppercase transition-all duration-300 font-mono group overflow-hidden';
  const variants = {
    primary: 'bg-[#c9a84c] text-[#050a0f] hover:bg-[#f0d080] shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.6)] border border-[#c9a84c]',
    secondary: 'bg-transparent text-[#00d4ff] border border-[#00d4ff] hover:bg-[#00d4ff]/10 shadow-[0_0_10px_rgba(0,212,255,0.2)] hover:shadow-[0_0_20px_rgba(0,212,255,0.4)]',
    outline: 'bg-transparent text-[#c8c0b0] border border-[#c8c0b0]/30 hover:border-[#c8c0b0] hover:bg-[#c8c0b0]/5'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-233">
      <span className="relative z-10 flex items-center gap-2" data-id="element-234">
        {children}
        {icon && <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-235" />}
      </span>

      {/* Glitch effect overlay on hover */}
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 skew-y-12" data-id="element-236" />
    </button>;
}